import React from 'react';
import { Layout, Typography } from 'antd';
import { useForm, FormProvider, WatchObserver } from 'react-hook-form';
import { useNavigate } from 'react-router';

import { useQuery } from 'hooks/useQuery';
import { InputField } from 'components/form/base/InputField';
import { mapSelect } from 'utils/mappings';
import { debounce, omit, removeEmptyValues } from 'utils/helpers';
import { Select } from 'components/form/base/Select';
import { b2bFilterStatuses } from 'constants/b2bFilterStatuses';
import { stateStatusesNamesHash } from 'types/stateStatus';

type TFormSelectValue = { value: string; label: string };

interface IFormValues {
  name: string;
  noticeNumber: string;
  status: string | TFormSelectValue;
  state: string | TFormSelectValue;
}

export const Filters = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const updateFilters = filters => {
    const queryString = new URLSearchParams(filters).toString();
    navigate(`${location.pathname}?${queryString}`);
  };

  const debounceSubmit = React.useCallback(
    debounce((values: IFormValues) => {
      const preparedValues = {
        name: values.name && values.name.trim(),
        noticeNumber: values.noticeNumber && values.noticeNumber.trim(),
        status: mapSelect(values.status),
        state: mapSelect(values.state),
      };
      updateFilters(removeEmptyValues(preparedValues));
    }, 500),
    []
  );

  const methods = useForm({
    defaultValues: {
      name: '',
      noticeNumber: '',
      status: '',
      state: '',
      ...omit(query, 'limit', 'offset'),
    },
  });

  React.useEffect(() => {
    const subscription = methods.watch(
      methods.handleSubmit(debounceSubmit) as WatchObserver<IFormValues>
    );
    return () => subscription.unsubscribe();
  }, [methods.handleSubmit, methods.watch]);

  return (
    <Layout.Content
      style={{ background: '#fff', paddingTop: '16px', paddingBottom: '1px' }}
    >
      <Typography.Title level={5} style={{ marginBottom: '24px' }}>
        Фильтры
      </Typography.Title>
      <FormProvider {...methods}>
        <form className='ant-form ant-form-vertical'>
          <InputField
            name='name'
            label='Название'
            placeholder='Введите название'
            maxLength={255}
          />
          <InputField
            name='noticeNumber'
            label='Номер извещения'
            placeholder='Введите номер извещения'
            maxLength={255}
          />
          <Select name='status' label='Статус' options={b2bFilterStatuses} />
          <Select
            name='state'
            label='Статус процедуры аренды'
            options={[
              { value: '', label: 'Все' },
              ...Object.keys(stateStatusesNamesHash).map(item => ({
                value: item,
                label: stateStatusesNamesHash[item],
              })),
            ]}
          />
        </form>
      </FormProvider>
    </Layout.Content>
  );
};
